export default __webpack_public_path__ + "static/media/google-review.c6ff97c8.png";